// src/components/ProductList.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ProductList = ({ onProductDeleted, onEditProduct }) => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);

  const [searchName, setSearchName] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const [alert, setAlert] = useState({ message: '', type: '' });

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, []);

  // FETCH PRODUCTS
  const fetchProducts = async () => {
    try {
      const response = await axios.get('https://royaleva.hxbindia.com/products');
      const sortedProducts = [...response.data].sort((firstProduct, secondProduct) => {
        const nameSort = firstProduct.name.localeCompare(secondProduct.name, undefined, { sensitivity: 'base' });

        if (nameSort !== 0) {
          return nameSort;
        }

        return (firstProduct.color || '').localeCompare(secondProduct.color || '', undefined, { sensitivity: 'base' });
      });

      setProducts(sortedProducts);
      setFilteredProducts(sortedProducts);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  // FETCH CATEGORIES
  const fetchCategories = async () => {
    try {
      const res = await axios.get("https://royaleva.hxbindia.com/categories");
      setCategories(res.data); // expecting array of categories
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  // FILTER LOGIC
  useEffect(() => {
    let updated = [...products];

    // Name Search
    if (searchName.trim() !== "") {
      updated = updated.filter(product =>
        product.name.toLowerCase().includes(searchName.toLowerCase())
      );
    }

    // Category Filter
    if (selectedCategory) {
      updated = updated.filter(product => product.categoryName === selectedCategory);
    }

    setFilteredProducts(updated);
  }, [searchName, selectedCategory, products]);

  // DELETE
  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://royaleva.hxbindia.com/products/${id}`);

      const updated = products.filter((p) => p._id !== id);
      setProducts(updated);
      setFilteredProducts(updated);

      onProductDeleted();

      setAlert({ message: 'Product deleted successfully!', type: 'success' });
      setTimeout(() => setAlert({ message: '', type: '' }), 3000);

    } catch (error) {
      console.error("Error deleting product:", error);
      setAlert({ message: 'Error deleting product.', type: 'danger' });
      setTimeout(() => setAlert({ message: '', type: '' }), 3000);
    }
  };

  return (
    <div>
      <div className="container d-flex justify-content-center">
        <div className="col-md-9 pt-5">

          <h2>Products</h2>

          {/* SEARCH + CATEGORY FILTER */}
          <div className="row mb-4 mt-3">

            <div className="col-md-6 mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Product Name..."
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
              />
            </div>

            {/* <div className="col-md-6 mb-2">
              <select
                className="form-control"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <option value="">All Categories</option>

                {categories.map((cat) => (
                  <option key={cat._id} value={cat.name}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div> */}

          </div>

          {alert.message && (
            <div className={`alert alert-${alert.type}`} role="alert">
              {alert.message}
            </div>
          )}

          <ul className="list-group">
            {filteredProducts.map((product) => (
              <li key={product._id} className="list-group-item d-flex justify-content-between align-items-center">
                <div>

                  <h6>Product Images</h6>
                  {product.image.map((img, idx) => (
                    <img
                      key={idx}
                      src={`https://royaleva.hxbindia.com${img}`}
                      style={{ width: "100px", marginRight: "8px" }}
                    />
                  ))}

                  <p><b>Product Name:</b> {product.name}</p>
                  <p><b>Category:</b> {product.categoryName}</p>
                  <p><b>Color:</b> {product.color}</p>
                  <p><b>Description:</b> {product.description}</p>

                </div>

                <div>
                  <button
                    className="btn btn-warning btn-sm me-2"
                    onClick={() => onEditProduct(product)}
                  >
                    Edit
                  </button>

                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(product._id)}
                  >
                    Delete
                  </button>
                </div>

              </li>
            ))}
          </ul>

        </div>
      </div>
    </div>
  );
};

export default ProductList;
